import React from 'react'
import Portal from '../portal'
import './index.scss'
import {
    getImgUrl
} from '../../common/util'

class ProductMedia extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            index: 0,
            showWindow: window._inject_app_data_.showWindow,
            images: window._inject_app_data_.detailImgs.slice(),
            video: window._inject_app_data_.video,
            showVideo: !!window._inject_app_data_.video,
            upperStyle: {},
            lowerStyle: 0,
            isDrag: false
        }
        this.video = null
    }

    componentDidMount() {
        this.state.showVideo && (this.video = document.getElementById('product-media-video'))
    }

    changeIndex = index => {
        if (index === this.state.index) {
            return
        }
        const length = this.state.images.length
        if (index < 0) {
            index = length - 1
        } else if (index >= length) {
            index = 0
        }
        this.setState({
            index,
            upperStyle: {
                left: index === 0 ? '0' : `-${index * 765}px`
            }
        })
        if (this.video) {
            index === 0
                ? setTimeout(() => {
                    this.video.play()
                }, 600)
                : this.video.pause()
        }
        if (length < 6) {
            return
        }
        const step = 147
        const left = index * step
        const right = left + step - 1
        const windowLeft = this.state.lowerStyle
        const windowRight = windowLeft + 765
        const maxLeft = length * step - 765 - 1
        let lowerStyle
        if (left <= windowLeft) {
            lowerStyle = windowLeft - step
        } else if (right >= windowRight) {
            lowerStyle = windowLeft + step
        }
        if (lowerStyle !== undefined) {
            if (lowerStyle < 0) {
                lowerStyle = 0
            } else if (lowerStyle > maxLeft) {
                lowerStyle = maxLeft
            }
            this.setState({
                lowerStyle
            })
        }
    }

    dragImg = e => {
        e.preventDefault()
    }

    dragStart = (e, index) => {
        const startX = e.screenX
        const ttc = Date.now() + 500
        const { images, lowerStyle } = this.state
        const _this = this
        const listenToMove = images.length >= 6
        const maxLeft = images.length * 147 - 765 - 1
        let isDrag = false
        this.setState({
            isDrag: true
        })

        function mousemoveHandler(ee) {
            isDrag = true
            let position = lowerStyle - ee.screenX + startX
            if (position < 0) {
                position = 0
            } else if (position > maxLeft) {
                position = maxLeft
            }
            _this.setState({
                lowerStyle: position
            })
        }

        function mouseupHandler() {
            if (Date.now() <= ttc && !isDrag) {
                _this.changeIndex(index)
            }
            listenToMove && document.body.removeEventListener('mousemove', mousemoveHandler)
            document.body.removeEventListener('mouseup', mouseupHandler)
            _this.setState({
                isDrag: false
            })
        }

        listenToMove && document.body.addEventListener('mousemove', mousemoveHandler)
        document.body.addEventListener('mouseup', mouseupHandler)
    }

    render() {
        const { index, showWindow, images, video, showVideo, upperStyle, lowerStyle, isDrag } = this.state
        return <div>
            <div className="product-media-wrapper">
                <div className='product-media-window'>
                    <ul className='product-media-content' style={upperStyle}>
                        {
                            images.map((img, i) => (<li className='product-media-block'>
                                {
                                    i === 0 && showVideo
                                        ? <video controls muted autoPlay loop src={video} poster={getImgUrl(img)} className='product-media-video' id="product-media-video"></video>
                                        : <img alt='' className='product-media-pic' src={getImgUrl(img)} onDragStart={this.dragImg}></img>
                                }
                            </li>))
                        }
                    </ul>
                    {
                        showWindow && <i className='product-media-arrow left' onClick={() => this.changeIndex(index - 1)}></i>
                    }
                    {
                        showWindow && <i className='product-media-arrow right' onClick={() => this.changeIndex(index + 1)}></i>
                    }
                </div>
            </div>
            {
                showWindow && <div className="product-media-ul-wrapper">
                    <div className="product-media-ul-window">
                        <ul className="product-media-ul" style={{ left: lowerStyle ? `-${lowerStyle}px` : '0' }}>
                            {
                                images.map((img, i) => (<li className={
                                    isDrag
                                        ? i === index
                                            ? 'product-media-item grabbing active'
                                            : 'product-media-item grabbing'
                                        : i === index
                                            ? 'product-media-item active'
                                            : 'product-media-item'
                                } onMouseDown={e => this.dragStart(e, i)}>
                                    <img alt="" className="img" src={getImgUrl(img)} onDragStart={this.dragImg}></img>
                                    {
                                        i === 0 && showVideo && <i className='video' onDragStart={this.dragImg}></i>
                                    }
                                </li>))
                            }
                        </ul>
                    </div>
                </div>
            }
        </div>
    }
}

export default Portal(ProductMedia, 'product-media-container')